import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, Content, Events, ModalController, Modal, Keyboard } from 'ionic-angular';
import { HttpServiceProvider } from '../../providers/http-service/http-service';
import { AdicionarProdutoPage } from '../adicionar-produto/adicionar-produto';
import { DomSanitizer } from '@angular/platform-browser';
import { ListarcomandaPage } from '../listarcomanda/listarcomanda';
import { File } from '@ionic-native/file'
import { CartService } from '../cart.service';
import { AlertProvider } from '../../providers/alert/alert';

@IonicPage({
  segment: 'home/:nroComanda'
})

@Component({
  selector: 'page-grupos',
  templateUrl: 'grupos.html',
})
export class GruposPage {
  @ViewChild(Content) content: Content;
  telaCarregada = false;
  nroComanda: number = 0;
  emp_fantasia: string = "";
  grupos: any[] = []
  gruposProdutos: any[] = []
  gruposAuxiliar: any[] = []
  produtos: any[] = [];
  produtosAuxiliar: any[] = [];
  searchTerm: string = "";
  Cart: any[] = [];
  noOfItems: any;
  subTotal: any;
  grupoSelecionado: number = 1;
  indexGrupo: number = 0;
  posicoes: any[] = []
  codGrupo: string = ""
  modal: Modal;
  valorTotalPedido: number = 0
  backgroundColor: string = "#ffa500"
  temProdutosCart: boolean = false
  mostraLoading: boolean = true
  loading: any;
  dadosEmpresa = {
    Emp_Bairro: "",
    Emp_CNPJ: "",
    Emp_Cep: "",
    Emp_Cidade: "",
    Emp_CodMunicipio: "",
    Emp_Complemento: "",
    Emp_Cor: "",
    Emp_Email: "",
    Emp_Endereco: "",
    Emp_IE: "",
    Emp_Logo: "",
    Emp_NomeFantasia: "",
    Emp_NumEndereco: "",
    Emp_Numero: "",
    Emp_RamoAtividade: "",
    Emp_RazaoSocial: "",
    Emp_Telefone: "",
    Emp_UF: "",
    Emp_WhatsApp: "",
    Emp_Online: ""
  }

  constructor(
    public data: CartService,
    public navCtrl: NavController,
    public navParams: NavParams,
    public httpService: HttpServiceProvider,
    public sanitizer: DomSanitizer,
    public alertCtrl: AlertController,
    public alertCustom: AlertProvider,
    public events: Events,
    public modalCtrl: ModalController,
    public file: File,
    public keyboard: Keyboard
  ) {
    this.loading = "../../assets/imgs/loading2.gif"
    localStorage.setItem("NovosProdutos", JSON.stringify(null))
    let aux = location.hostname.split(".", 2)
    this.httpService.getDadosServidor(aux[0] == "www" ? aux[1] : aux[0]).toPromise().then((result: any) => {
      localStorage.setItem("filial", result.filial)
      localStorage.setItem("porta", result.porta)
      localStorage.setItem("database", result.database)
      localStorage.setItem("ipservidor", result.ipservidor)


      this.httpService.get("listarGrupos").toPromise().then((grupos: any[]) => {
        localStorage.setItem("grupos", JSON.stringify(grupos))
        this.grupos = grupos
        this.gruposAuxiliar = grupos
        this.gruposProdutos = grupos
        this.grupoSelecionado = grupos[0].Gru_Codigo;

        this.httpService.get("listarProdutos").toPromise().then((produtos: any[]) => {
          localStorage.setItem("produtos", JSON.stringify(produtos))
          this.data.produtos = produtos
          this.produtos = produtos
          this.produtosAuxiliar = produtos
          this.telaCarregada = true;
        })

        if (this.Cart != null) {
          this.noOfItems = this.Cart.length;
          this.callFunction();
        }

        setTimeout(() => {
          this.httpService.get('listarEmpresa').toPromise().then((result: any) => {
            this.dadosEmpresa = Object.assign({}, result)
            localStorage.setItem("dadosEmpresa", JSON.stringify(result))
            if (result.Emp_Online == "N") {
              this.alertCustom.alertValidaCampos("Estamos fechados para pedidos no momento.", "")
            }
          })
          this.salvaPocicoesGruposSuperior()
        }, 3000);
      })
    })
  }

  ionViewWillEnter() {
    this.Cart = JSON.parse(localStorage.getItem("NovosProdutos"));
  }

  salvaPocicoesGruposSuperior() {
    if (this.grupos) {
      document.querySelector("ion-segment-button[ng-reflect-value]").classList.add('segment-activated')
      for (let i = 0; i < this.grupos.length; i++) {
        let y = document.getElementById(this.grupos[i].Gru_Codigo).offsetTop - 28;
        let obj = {
          grupcodigo: this.grupos[i].Gru_Codigo,
          scrollTop: y
        }
        this.posicoes.push(obj)
      }
      this.mostraLoading = false
    }
  }

  formataTelefone(telefone) {
    let telefoneFormatado = ""
    if (telefone) {
      if (telefone.length == 10) {
        telefoneFormatado = '(' + telefone.substr(0, 2) + ') ' + telefone.substr(2, 4) + '-' + telefone.substr(6, 4)
      } else {
        telefoneFormatado = '(' + telefone.substr(0, 2) + ') ' + telefone.substr(2, 5) + '-' + telefone.substr(7, 4)
      }
      return telefoneFormatado
    }
  }

  public setOption(index, event) {
    if (this.grupos[index] != null) {
      this.grupoSelecionado = this.grupos[index].Gru_Codigo;
      this.indexGrupo = index;


      let segments = event.target.parentNode.children;
      let len = segments.length;
      for (let i = 0; i < len; i++) {
        segments[i].classList.remove('segment-activated');
      }
      event.target.classList.add('segment-activated');
    }
  }

  abrirModalPedido() {
    this.modal = this.modalCtrl.create(ListarcomandaPage);
    this.modal.present();
    this.modal.onDidDismiss(() => {
      this.Cart = JSON.parse(localStorage.getItem("NovosProdutos"));
    })
  }


  calculaValorTotalPedido() {
    this.valorTotalPedido = 0
    if (this.Cart) {
      for (let i = 0; i < this.Cart.length; i++) {
        this.valorTotalPedido = this.valorTotalPedido + this.Cart[i].vlrTotalItem
      }
    }
    return this.valorTotalPedido.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }

  calculaQtdePedido() {
    return this.Cart ? this.Cart.length : 0
  }

  ngAfterViewInit() {
    this.content.ionScroll.subscribe((event) => {
      if (event.scrollTop > 350) {
        document.getElementById("header").style.visibility = "visible"
      } else {
        document.getElementById("header").style.visibility = "hidden"
      }
      this.posicoes.map(item => {
        if (event.scrollTop) {
          if ((event.scrollTop - 40) < item.scrollTop && (event.scrollTop + 40) > item.scrollTop) {
            let aux = document.querySelectorAll("ion-segment-button[ng-reflect-value]")
            for (let h = 0; h < aux.length; h++) {
              aux[h].classList.remove('segment-activated')
            }
            document.querySelector('ion-segment-button[title=A' + item.grupcodigo + ']').classList.add('segment-activated')
            document.querySelector('ion-segment-button[title=A' + item.grupcodigo + ']').scrollIntoView()
          }
        }
      })
    });
  }

  scrollTo(elementId) {
    if(this.telaCarregada){
      let y = document.getElementById(elementId).offsetTop - 70;
      this.content.scrollTo(0, y);
    }
  }

  callFunction() {
    let subTotal = 0;
    for (var i = 0; i <= this.Cart.length - 1; i++) {
      subTotal = subTotal + this.Cart[i].vlrTotalItem;
    }
    this.subTotal = Number(subTotal.toFixed(2));
  }

  navCart() {
    this.navCtrl.pop();
  }

  filtrarProdutos() {
    this.produtos = this.produtosAuxiliar.filter(produto => {
      return produto.Prod_Nome.toLowerCase().includes(this.searchTerm.toLowerCase());
    });
  }

  adicionarProduto(produto, complementos) {
    this.navCtrl.push(AdicionarProdutoPage, { 'produto': produto, 'complementos': complementos });
  }

  retornaImagemSeguraURL(imagem) {
    let base64imgAux = 'data:image/png;base64,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'
    return this.sanitizer.bypassSecurityTrustResourceUrl(imagem || base64imgAux)
  }

  async abrirImagemProduto(imagem) {
    if (imagem) {
      const alert = await this.alertCtrl.create();
      await alert.present();
      var img = document.createElement("img")
      img.src = imagem
      document.querySelector(".alert-message").appendChild(img)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/grupos/grupos.ts